"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDirection = function (uMs, vMs, angleConvention) {
    // Default angle convention is CW
    if (angleConvention.endsWith('CCW')) {
        // vMs comes out upside-down..
        vMs = vMs > 0 ? vMs = -vMs : Math.abs(vMs);
    }
    var velocityAbs = Math.sqrt(Math.pow(uMs, 2) + Math.pow(vMs, 2));
    var velocityDir = Math.atan2(uMs / velocityAbs, vMs / velocityAbs);
    var velocityDirToDegrees = velocityDir * 180 / Math.PI + 180;
    if (angleConvention === 'bearingCW' || angleConvention === 'meteoCCW') {
        velocityDirToDegrees += 180;
        if (velocityDirToDegrees >= 360)
            velocityDirToDegrees -= 360;
    }
    return velocityDirToDegrees;
};
var getSpeed = function (uMs, vMs, unit) {
    var velocityAbs = Math.sqrt(Math.pow(uMs, 2) + Math.pow(vMs, 2));
    // Default is m/s
    if (unit === 'k/h') {
        return meterSec2kilometerHour(velocityAbs);
    }
    else if (unit === 'kt') {
        return meterSec2Knots(velocityAbs);
    }
    else {
        return velocityAbs;
    }
};
// Converts from degrees to radians.
function toRadians(degrees) {
    return degrees * Math.PI / 180;
}
;
// Converts from radians to degrees.
function toDegrees(radians) {
    return radians * 180 / Math.PI;
}
function getBearing(startLat, startLng, destLat, destLng) {
    startLat = toRadians(startLat);
    startLng = toRadians(startLng);
    destLat = toRadians(destLat);
    destLng = toRadians(destLng);
    var y = Math.sin(destLng - startLng) * Math.cos(destLat);
    var x = Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
    var brng = Math.atan2(y, x);
    brng = toDegrees(brng);
    return ((brng + 360) % 360);
}
exports.getBearing = getBearing;
var meterSec2Knots = function (meters) {
    return meters / 0.514;
};
var meterSec2kilometerHour = function (meters) {
    return meters * 3.6;
};



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/classes/helper.js
// module id = 594
// module chunks = 0